import Analytics, {AnalyticsPlugin} from "analytics";
import awsPinpointPlugin from "@analytics/aws-pinpoint";
import {fetchAuthSession} from "aws-amplify/auth";

const PINPOINT_APP_ID = import.meta.env.VITE_APP_PINPOINT_APP_ID as string;

const analyticsPlugins: AnalyticsPlugin[] = [];

if (PINPOINT_APP_ID) {
    analyticsPlugins.push(
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call
        awsPinpointPlugin({
            pinpointAppId: PINPOINT_APP_ID,
            getCredentials: () => fetchAuthSession().then((session) => session.credentials),
        }) as AnalyticsPlugin,
    );
}

const analytics = Analytics({
    app: "irriwatch",
    plugins: analyticsPlugins,
    debug: true,
});

export default analytics;
